export default function GalleryFileInput({ inputRef, onSelect }) {
  const handleChange = event => {
    onSelect(event.target.files?.[0]);
    event.target.value = '';
  };

  return <input ref={inputRef} type="file" accept="image/*" onChange={handleChange} hidden />;
}
